import { Icon, Tooltip } from '@mairistem/composants';
import { Feature, Menu } from '@mairistem/module';

import { MENUS } from '@/constants';
import { showTooltips } from '@/utils';
import { ArreteAnnuel } from './ArreteAnnuel';
import { ArretePeriodique } from './ArretePeriodique';
import { ArretesJournaliers } from './ArretesJournaliers';

const MenuArretes = () => (
  <Menu
    code={MENUS.MENU_ARRETES}
    name="Arrêtés de régie"
    icon={
      showTooltips ? (
        <Tooltip
          trigger={<Icon name="stop circle" />}
          message="Arrêtés de régie"
          position="right center"
        />
      ) : (
        <Icon name="stop circle" />
      )
    }
    path="/arretes"
  >
    <Menu code={MENUS.MENU_ARRETE_JOURNALIER} name="Arrêtés journaliers" path="/journaliers">
      <Feature>
        <Feature.Content>
          <ArretesJournaliers />
        </Feature.Content>
      </Feature>
    </Menu>
    <Menu code={MENUS.MENU_ARRETE_PERIODIQUE} name="Arrêtés périodiques" path="/periodique">
      <Feature>
        <Feature.Content>
          <ArretePeriodique />
        </Feature.Content>
      </Feature>
    </Menu>
    <Menu code={MENUS.MENU_ARRETE_ANNUEL} name="Arrêtés annuels" path="/annuel">
      <Feature>
        <Feature.Content>
          <ArreteAnnuel />
        </Feature.Content>
      </Feature>
    </Menu>
  </Menu>
);

export default MenuArretes;
